import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {Dialog} from '../../../../interfaces/dialog/dialog';
import {LoaderService} from '../../../../services/loader/loader.service';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {DialogParams} from '../../../../interfaces/dialog/dialog-params';
import {UserService} from '../../../../services/user/user.service';
import {User} from '../../../../models/user';
import {ActivityService} from '../../../../services/crm/activity/activity.service';
import {Partner} from '../../../../models/partner/partner';
import {Activity} from '../../../../models/crm/activity';
import {AuthService} from '../../../../services/auth/auth.service';
import {ActivityForm} from '../../../../forms/activity-form';

@Component({
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './partner-activity-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-activity-form.component.scss'
})
export class PartnerActivityFormComponent implements Dialog {

  private partner: Partner | null = null;
  private activity: Activity | null = null;

  connectedUser!: User;

  loaded: boolean = false;
  users: User[] = [];
  type!: string;
  hasAlert: boolean = false;

  form = ActivityForm.getFormGroup();

  constructor(
    private authService: AuthService,
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private activityService: ActivityService,
    private userService: UserService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    if (!params.data || (!params.data.type && !params.data.activity)) {
      console.error('Type must be defined');
    }

    this.authService.getConnectedUser().subscribe((connectedUser: User) => {
      this.connectedUser = connectedUser;

      this.form.get('recipientId')?.patchValue(this.connectedUser.id);
    });

    if (params.data.activity) {
      this.activity = params.data.activity;
      if (this.activity) {
        this.type = this.activity.type;
        this.hasAlert = this.activity.alertTime !== null;
        ActivityForm.update(this.form, this.activity);
      }
    } else {
      this.type = params.data.type;
      this.partner = params.data.partner;
    }

    this.userService.findAll({team: true, sort: 'firstname,lastname'}).subscribe((users: User[]) => {
      this.users = users.filter((user: User) => user.id !== this.connectedUser.id);
      this.loaded = true;
    });
  }

  isCreate(): boolean {
    return this.activity === null;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    this.loader.startLoading();

    const data: any = this.form.value;
    const params: any = {};

    if (this.isCreate()) {
      params['type'] = this.type;

      if (this.partner) {
        params['partnerId'] = this.partner.id;
      }
    }

    params['recipientId'] = data.recipientId;
    params['subject'] = data.subject;
    params['message'] = data.message;
    params['pinned'] = data.pinned;

    if (this.type === 'task') {
      if (data.occurringDate && data.occurringTime) {
        params['occurringAt'] = data.occurringDate + ' ' + data.occurringTime + ':00';
      } else {
        params['occurringAt'] = null;
      }
      params['repeatFrequency'] = data.repeatFrequency;
      if (this.hasAlert && data.alert) {
        params['alertTime'] = data.alertTime;
      }
    }

    if (this.isCreate()) {
      this.activityService.create(params).subscribe(() => {
        this.snackbar.success('A ' + this.type + ' has been created.');
        this.loader.stopLoading();
        this.dialog.closeDialog();
      });
    } else if (this.activity && this.activity.id) {
      this.activityService.update(this.activity.id, params).subscribe(() => {
        this.snackbar.success('The ' + this.type + ' has been updated.');
        this.loader.stopLoading();
        this.dialog.closeDialog();
      });
    } else {
      console.error('Cannot submit activity update', this.activity);
    }
  }
}
